import { createSelector, createFeatureSelector } from "@ngrx/store";

import { IState } from "@models/index";

export const categorySelector = createFeatureSelector<IState>("category");
export const getCategoriesSelector = createSelector(
  categorySelector,
  (state: IState) => state.data
);
export const GET_ACTIVE_CATEGORY = createSelector(
  categorySelector,
  (state: IState) => state.selectedItem
);
